import { Coupon } from '@dtx-company/true-common/src/types/Coupon'
import { Plan } from '@dtx-company/true-common/src/types/Plan'

export function promoAppliesToSelectedPlan(
  promo: Partial<Coupon>,
  selectedPlan: Partial<Plan>
): boolean {
  return promo?.planIds?.includes(selectedPlan?.id ?? '') ?? false
}
